import differenceInMinutes from 'date-fns/differenceInMinutes'

export function getDifferenceInMinutes(value) {
  return differenceInMinutes(new Date(), new Date(`${value}Z`))
}
